import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import TablerLayout from "../components/layout/TablerLayout";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const Alairas = () => {
	const sigCanvas = useRef({});
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();
	const [isSigned, setIsSigned] = useState(false);

	const [showNoSignatureModal, setShowNoSignatureModal] = useState(false);

	const goNext = async () => {
		if (sigCanvas.current.isEmpty()) {
            return;
        }
		const url = sigCanvas.current.getCanvas().toDataURL("image/png");
		try {
			const updatedOrder = {
				...order,
				hmeliorder: {
					...order.hmeliorder,
					alairas_image: url,
				},
			};
			updateOrder(updatedOrder);

			const result = await saveOrder(updatedOrder);
			if (result.success) {
				showSuccessToast("A rendelés sikeresen mentve!");
				navigate("/MeretlapNyomtatas");
			} else {
				showErrorToast("Hiba történt a rendelés mentésekor!");
			}
		} catch (error) {
			console.error("Hiba a rendelés mentésekor:", error);
		}
	};

	const clearCanvas = () => {
		sigCanvas.current.clear();
		setIsSigned(false);
	};

	const handleDrawEnd = () => {
        setIsSigned(true);
    };

	return (
		<TablerLayout title="Kérjük, írja alá a mezőben! Ügyeljen arra, hogy a szaggatott vonalból ne lépjen ki!">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="card-body">
						<h5 className="mb-4 fw-bold"></h5>
						<div className="mb-4 d-flex flex-column align-items-center">
							<SignatureCanvas
								ref={sigCanvas}
								penColor="rgb(0,115,227)"
								onEnd={handleDrawEnd}
								canvasProps={{
									width: 700,
									height: 380,
									className: "signature-canvas",
									style: {
										border: "2px dashed var(--primary-color)",
										background: "#fff",
										width: "100%",
										maxWidth: "700px",
										height: "380px",
										display: "block",
										margin: "0 auto 1rem auto",
										boxShadow: "0 0.5rem 1rem rgba(93,149,52,0.10)",
									},
								}}
								velocityFilterWeight={0.7}
								minWidth={0.5}
								maxWidth={2.5}
							/>
							<div className="d-flex gap-3 justify-content-center">
								<button type="button" className="btn btn-outline-primary px-4 fw-bold" onClick={clearCanvas}>
									Újrapróbálás
								</button>
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-between mt-4">
						<StepperNavButton
							side="left"
							label="Vissza"
							onClick={() => (Array.isArray(order.divitems) && order.divitems.length == 0 ? navigate("/FelolvasoTabla") : navigate("/Diviziok"))}
							disabled={orderSaveLoading}
						/>
						<StepperNavButton side="right" label="Tovább" onClick={() => goNext()} disabled={!isSigned || orderSaveLoading} />
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default Alairas;
